<script lang="ts" setup>
import { computedAsync } from '@vueuse/core';
import CategoriesService from '../../../runtime/services/CategoriesService';
import FieldSelect from './FieldSelect.vue';

defineOptions({
    name: 'FieldCategory',
    components: {
        'field-select': FieldSelect
    }
});

const model = defineModel<number | null>();
const props = withDefaults(defineProps<{
    label: string;
    invalidFeedback?: (value: any) => string;
    required?: boolean;
    disabled?: boolean;
    name?: string;
}>(), {
    invalidFeedback: null,
    required: false,
    disabled: false,
    name: undefined
});

const { $alert } = useAlerts();
const { $log } = useLogging();

const options = computedAsync(async () =>
{
    try
    {
        const pager = new Pager(1, 10000, 'Name', 'ASC');
        const response = await CategoriesService.getOptions(pager, null, null);

        return [{ value: null, text: '' }, ...response.items];
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });

        return [];
    }
});
</script>

<template>
    <FieldSelect
        v-if="options"
        v-model="model"
        :name="name"
        :options="options"
        :label="props.label"
        :invalid-feedback="props.invalidFeedback"
        :required="props.required"
        :disabled="props.disabled"
    />
</template>
